export const PostGameStat: React.FC<{
  children: React.ReactNode;
  value: string;
}> = ({ children, value }) => {
  return (
    <div className="flex items-baseline gap-2">
      <div>{children}</div>
      <div className="grow border-b border-dotted" />
      <div className="title title-md">{value}</div>
    </div>
  );
};
